import { Box, CircularProgress } from '@mui/material';
import * as React from 'react';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'center',
    margin: 8
  }
} as const;

export function LoadingPage() {
  return (
    <Box sx={styles.root}>
      <CircularProgress />
    </Box>
  );
}
